import { render, staticRenderFns } from "./MedicalInstitutionView.vue?vue&type=template&id=35b3bbab"
import script from "./MedicalInstitutionView.vue?vue&type=script&lang=js"
export * from "./MedicalInstitutionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports